<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  [hasPrimaryAction]="true"
  primaryActionIcon="print"
  [primaryActionText]="'printReport' | translate"
  (primaryAction)="print()"
  (backAction)="back()"
  [buttonItems]="buttonItems$ | async"
  (buttonAction)="buttonAction($event)"
  [selectItems]="selectItems$ | async"
  (selectAction)="selectAction($event)"
>
  <agr-print-page
    [footerText]="'gbmWarningFooter' | translate"
    [relatedPeople]="loggedInEmployee$ | async"
    [marginLeft]="true"
    [showPageNumber]="false"
  >
    <div class="wrapper--spacing-horizontal print-only">
      <div class="avoid-page-break" *ngrxLet="customer$ as customer">
        @if (customer) {
          <agr-value-row [label]="'reportFor' | translate" class="customer">{{
            customer.name
          }}</agr-value-row>
          <agr-value-row [label]="'address' | translate"
            >{{ customer.street }} {{ customer.houseNumber }}
            {{ customer.houseNumberAddition }}
          </agr-value-row>
          <agr-value-row [label]="'city' | translate"
            >{{ customer.postalCode }} {{ customer.city }}
          </agr-value-row>
          <agr-value-row [label]="'mobile' | translate">{{ customer.mobileNumber }}</agr-value-row>
          <agr-value-row [label]="'telephone' | translate">{{
            customer.phoneNumber
          }}</agr-value-row>
          <agr-value-row [label]="'email' | translate">{{ customer.emailAddress }}</agr-value-row>
          <agr-value-row [label]="'customerNumber' | translate">{{
            customer.externalId
          }}</agr-value-row>
        }
      </div>
      <div class="avoid-page-break" *ngrxLet="loggedInEmployee$ as loggedInEmployee">
        <h2 class="text--h5">{{ 'contactTitle' | translate }}</h2>
        @if (loggedInEmployee[0]) {
          <agr-value-row [label]="'adviser' | translate"
            >{{ loggedInEmployee[0].lastName }}, {{ loggedInEmployee[0].firstName }}</agr-value-row
          >
          <agr-value-row [label]="'mobile' | translate">
            {{ loggedInEmployee[0].mobilePhoneNumber }}
          </agr-value-row>
          <agr-value-row [label]="'email' | translate">
            {{ loggedInEmployee[0].emailAddress }}
          </agr-value-row>
        }
      </div>
    </div>

    @if (legalStandardBalance$ | async) {
      <div
        class="fertilization-legal-standards-table wrapper--spacing-horizontal text--body print-padding-top"
      >
        <h2 class="text--h3">{{ 'legalStandards' | translate }}</h2>
        <div class="avoid-page-break spacing--margin-top">
          <app-crop-field-legal-standards
            title="{{ 'mainCultivationsInKgHa' | translate }}"
            [cropFields]="mainCropFields$ | async"
          ></app-crop-field-legal-standards>
        </div>
        <div class="spacing--margin-vertical"><mat-divider></mat-divider></div>
        <div class="avoid-page-break">
          <app-crop-field-legal-standards
            title="{{ 'subsequentCultivationsInKgHa' | translate }}"
            [cropFields]="subsequentCultivations$ | async"
          ></app-crop-field-legal-standards>
        </div>
        @if ((legalStandardBalance$ | async)?.nitrogenCuts.cutsTotalInKgN > 0) {
          <div class="spacing--margin-vertical">
            <mat-divider></mat-divider>
          </div>
        }
        @if ((legalStandardBalance$ | async)?.nitrogenCuts.cutsTotalInKgN > 0) {
          <div class="avoid-page-break">
            <div class="flex--row print-border-all table-header">
              <div
                class="flex__child flex__child-3 table-header print-padding align-desktop-top align-print-center"
              >
                {{ 'nitrogenCuts.sectionTitle' | translate }}
              </div>
              <div
                class="flex__child flex__child-1 table-header text--center print-padding-vertical align-desktop-top align-print-center"
              >
                {{ 'hectares' | translate }}
              </div>
              <div class="flex__child flex__child-4">
                <div class="flex--row">
                  <div
                    class="flex__child flex__child-1 table-header text--center print-border-left"
                  ></div>
                  <div
                    class="flex__child flex__child-1 table-header text--center print-border-left"
                  ></div>
                  <div
                    class="flex__child flex__child-1 table-header text--center print-border-left"
                  >
                    <div class="print-border-bottom print-padding-vertical">
                      {{ 'nTotal' | translate }}
                    </div>
                    <div class="flex--row flex--nowrap">
                      <div class="flex__child flex__child-1 text--center text--label print-padding">
                        {{ 'standard' | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ng-container *ngrxLet="cropYear$ as cropYear">
              <ng-container *ngrxLet="legalStandardBalance$ as legalStandardBalance">
                <div
                  class="flex--row print-border-no-top nitrogen-cuts-container"
                  data-test="fertilization-legal-standards-nitrogenCuts"
                >
                  <div
                    class="flex__child flex__child-3 flex print-padding-horizontal"
                    style="align-self: center"
                    data-test="fertilization-legal-standards-nitrogenCut__name"
                  >
                    @if (cropYear !== 2025) {
                      {{ 'nitrogenCuts.period1Label' | translate }}
                    } @else {
                      {{ 'nitrogenCuts.period1Label2025' | translate }}
                    }
                  </div>
                  @if (legalStandardBalance.nitrogenCuts) {
                    <div
                      class="flex__child flex__child-1 text--center"
                      style="align-self: center"
                      data-test="fertilization-legal-standards-nitrogenCuts__hectares"
                    >
                      {{ legalStandardBalance.nitrogenCuts.period1Ha | agrNumber: '1.2-2' }}
                    </div>
                  }
                  <div class="flex__child flex__child-4">
                    <div class="flex--row">
                      <div
                        class="flex__child flex__child-1 flex--row text--center print-border-left"
                      >
                        <div class="flex__child flex__child-1 text--center print-padding"></div>
                        <div
                          class="flex__child flex__child-1 text--center print-padding print-border-left"
                        ></div>
                      </div>
                      <div
                        class="flex__child flex__child-1 flex--row text--center print-border-left"
                      >
                        <div class="flex__child flex__child-1 text--center print-padding"></div>
                        <div
                          class="flex__child flex__child-1 text--center print-padding print-border-left"
                        ></div>
                      </div>
                      <div
                        class="flex__child flex__child-1 flex--row text--center print-border-left"
                      >
                        <div
                          class="flex__child flex__child-1 text--center print-padding"
                          data-test="fertilization-legal-standards-subsequentCultivation__nTotalLegalStandard"
                        >
                          -5
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="flex--row print-border-no-top nitrogen-cuts-container"
                  data-test="fertilization-legal-standards-nitrogenCuts"
                >
                  <div
                    class="flex__child flex__child-3 flex print-padding-horizontal"
                    style="align-self: center"
                    data-test="fertilization-legal-standards-nitrogenCut__name"
                  >
                    @if (cropYear !== 2025) {
                      {{ 'nitrogenCuts.period2Label' | translate }}
                    } @else {
                      {{ 'nitrogenCuts.period2Label2025' | translate }}
                    }
                  </div>
                  @if (legalStandardBalance.nitrogenCuts) {
                    <div
                      class="flex__child flex__child-1 text--center"
                      style="align-self: center"
                      data-test="fertilization-legal-standards-nitrogenCuts__hectares"
                    >
                      {{ legalStandardBalance.nitrogenCuts.period2Ha | agrNumber: '1.2-2' }}
                    </div>
                  }
                  <div class="flex__child flex__child-4">
                    <div class="flex--row">
                      <div
                        class="flex__child flex__child-1 flex--row text--center print-border-left"
                      >
                        <div class="flex__child flex__child-1 text--center print-padding"></div>
                        <div
                          class="flex__child flex__child-1 text--center print-padding print-border-left"
                        ></div>
                      </div>
                      <div
                        class="flex__child flex__child-1 flex--row text--center print-border-left"
                      >
                        <div class="flex__child flex__child-1 text--center print-padding"></div>
                        <div
                          class="flex__child flex__child-1 text--center print-padding print-border-left"
                        ></div>
                      </div>
                      <div
                        class="flex__child flex__child-1 flex--row text--center print-border-left"
                      >
                        <div
                          class="flex__child flex__child-1 text--center print-padding"
                          data-test="fertilization-legal-standards-subsequentCultivation__nTotalLegalStandard"
                        >
                          -10
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="flex--row print-border-no-top nitrogen-cuts-container"
                  data-test="fertilization-legal-standards-nitrogenCuts"
                >
                  <div
                    class="flex__child flex__child-3 flex print-padding-horizontal"
                    style="align-self: center"
                    data-test="fertilization-legal-standards-nitrogenCut__name"
                  >
                    @if (cropYear !== 2025) {
                      {{ 'nitrogenCuts.period3Label' | translate }}
                    } @else {
                      {{ 'nitrogenCuts.period3Label2025' | translate }}
                    }
                  </div>
                  @if (legalStandardBalance.nitrogenCuts) {
                    <div
                      class="flex__child flex__child-1 text--center"
                      style="align-self: center"
                      data-test="fertilization-legal-standards-nitrogenCuts__hectares"
                    >
                      {{ legalStandardBalance.nitrogenCuts.period3Ha | agrNumber: '1.2-2' }}
                    </div>
                  }
                  <div class="flex__child flex__child-4">
                    <div class="flex--row">
                      <div
                        class="flex__child flex__child-1 flex--row text--center print-border-left"
                      >
                        <div class="flex__child flex__child-1 text--center print-padding"></div>
                        <div
                          class="flex__child flex__child-1 text--center print-padding print-border-left"
                        ></div>
                      </div>
                      <div
                        class="flex__child flex__child-1 flex--row text--center print-border-left"
                      >
                        <div class="flex__child flex__child-1 text--center print-padding"></div>
                        <div
                          class="flex__child flex__child-1 text--center print-padding print-border-left"
                        ></div>
                      </div>
                      <div
                        class="flex__child flex__child-1 flex--row text--center print-border-left"
                      >
                        <div
                          class="flex__child flex__child-1 text--center print-padding"
                          data-test="fertilization-legal-standards-subsequentCultivation__nTotalLegalStandard"
                        >
                          -20
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        }
        <div class="spacing--margin-vertical"><mat-divider></mat-divider></div>
        <div class="avoid-page-break">
          <app-legal-standard-balance
            [legalStandardBalance]="legalStandardBalance$ | async"
          ></app-legal-standard-balance>
        </div>
      </div>
    }
    <div class="screen-only wrapper--spacing-horizontal spacing--margin-top">
      <mat-divider></mat-divider>
    </div>
    <div
      class="fertilization-legal-standards-table wrapper--spacing-horizontal text--body print-padding-top print-to-front"
    >
      <div class="avoid-page-break spacing--margin-top">
        <app-fertilizers-overview
          [fertilizerDataByType]="fertilizerDataByType"
        ></app-fertilizers-overview>
      </div>
    </div>
    <div class="screen-only wrapper--spacing-horizontal spacing--margin-top">
      <mat-divider></mat-divider>
    </div>
    @if ((manureSpaceComment$ | async)?.length) {
      <div
        class="fertilization-legal-standards-table wrapper--spacing-horizontal text--body print-padding-top print-to-front"
      >
        <h2 class="text--h3">{{ 'comments' | translate }}</h2>
        <p>{{ manureSpaceComment$ | async }}</p>
      </div>
    }
  </agr-print-page>
</agr-page-detail>
